import { compose } from 'recompose'

import withResumeFlow from 'components/HOCs/WithResumeFlow'
import { withFlowRouter } from 'utils/FlowProvider'

export const enhance = compose<{}, {}>(withFlowRouter, withResumeFlow)
